import { colors, textStyles } from "../../../../theme/foundations/generated";
const ComponentStyle = {
    baseStyle: {
        dialog: {
            maxW: {
                sm: "100%",
                md: "658px",
                lg: "678px",
            },
            borderRadius: "0",
            minW: "320px",
            ".chakra-modal__close-btn": {
                height: "6",
                width: "6",
                top: "4",
                right: "4",
                _hover: {
                    "--close-button-bg": "transparent",
                },
            },
        },
        dialogContainer: {
            p: {
                sm: "6",
                md: "12",
            },
        },
        header: {
            paddingTop: "10",
            paddingBottom: "6",
            h4: {
                color: "semantic.text.primary",
            },
            h5: {
                mt: "0.5rem",
                color: "semantic.text.tertiary",
            },
        },
        body: {
            p: "0",
            color: "semantic.text.tertiary",
        },
        footer: {
            p: "0",
            justifyContent: "center",
        },
        overlay: {
            backgroundColor: `${colors.semantic.brand.primary}B3`,
        },
    },
    sizes: {
        default: {
            dialog: {
                paddingBottom: "10",
            },
            header: {
                paddingLeft: "16",
                paddingRight: "16",
                h4: textStyles.title.desktopMain,
                h5: textStyles.subtitle.desktopMain,
            },
            body: Object.assign({ paddingLeft: "16", paddingRight: "16" }, textStyles.body.largeMedium),
            footer: {
                paddingLeft: "16",
                paddingRight: "16",
                mt: "10",
                gap: "6",
                flexDirection: "row",
            },
        },
        mobile: {
            dialog: {
                paddingBottom: "6",
            },
            header: {
                paddingLeft: "4",
                paddingRight: "4",
                h4: textStyles.title.mobileMain,
                h5: textStyles.subtitle.mobileMain,
            },
            body: Object.assign({ paddingLeft: "4", paddingRight: "4" }, textStyles.body.largeMedium),
            footer: {
                paddingLeft: "4",
                paddingRight: "4",
                mt: "6",
                gap: "4",
                flexDirection: "column-reverse",
                button: {
                    width: "100%",
                },
            },
        },
    },
    defaultProps: {
        size: "default",
    },
};
export default ComponentStyle;
//# sourceMappingURL=Modal.default.js.map